import { render } from "./NavigationMyAccountComponent.vue?vue&type=template&id=2db92716"
import script from "./NavigationMyAccountComponent.vue?vue&type=script&lang=js"
export * from "./NavigationMyAccountComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__